import { render, staticRenderFns } from "./ResellerBlock.vue?vue&type=template&id=f895d210&scoped=true&"
import script from "./ResellerBlock.vue?vue&type=script&lang=js&"
export * from "./ResellerBlock.vue?vue&type=script&lang=js&"
import style0 from "./ResellerBlock.vue?vue&type=style&index=0&id=f895d210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f895d210",
  null
  
)

export default component.exports